export const maskEmail = (email) => {
  if (!email) return '';

  const [localPart, domain] = email.split('@');
  if (!domain) return email;

  const firstLetter = localPart.charAt(0);
  const maskedPart = '****';

  return `${firstLetter}${maskedPart}@${domain}`;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
